module.exports = __webpack_public_path__ + "static/media/reprint.59a333b2.svg";